module.exports = __webpack_public_path__ + "static/img/dn6-mayor.6f695e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dn6-mayor.png
// module id = OynH
// module chunks = 0